import {Board, EntityID, Task} from '../models/types';
import {TaskEditState} from './TaskEditController';
import {ResponsiveState, ViewMode} from "../models/view-types";
import {Signal, Signals} from "./Signals";
import {ITaskEditController} from "./AppSingleton";
import {DragData, DropResult} from "../dnd-system";

(window as any).Signals = Signals;

type SignalColumnMovedArgs = {
	columnId: string;
	newIndex: number
	oldIndex: number
};

// Глобальные сигналы приложения
export const AppSignals = {
	boardUpdated: new Signal<Board>("/board/updated"),
	taskMoved: new Signal<{
		taskId: string;
		fromColumnId: string;
		toColumnId: string;
		newIndex: number;
	}>("task/moved"),
	columnMoved: new Signal<SignalColumnMovedArgs>("/column/moved"),
	/** Сигнал принудительного раскрытия колонки */
	expandColumn: new Signal<string>("/column/expand"),

	appInvalidated: new Signal<void>("/app/invalidated"),
	// Новые сигналы для редактирования задач
	taskEditEnded: new Signal<void>("/task/edit/ended"),
	taskUpdated: new Signal<Task>("/task/updated"),
	taskDeleted: new Signal<string>("/task/deleted"), // taskId
	taskEditStateChanged: new Signal<TaskEditState>("/task/edit/state/changed"),
	editorBackdropClicked: new Signal<void>("/editor/backdrop/clicked"),

	viewModeChanged: new Signal<ViewMode>("/viewmove/changed"),
	responsiveStateChanged: new Signal<ResponsiveState>("/responsive/state/change"),

	// Добавление нового сигнала для сетевого статуса
	networkStatus: new Signal<boolean>("/network_status_changed"),
	filtersToggled: new Signal<boolean>("/filter/changed"),

	// Сигнал для активации добавления задачи в колонке
	activateTaskAdd: new Signal<string>("/task/append"),
	cancelTaskAdd: new Signal<string>("/task/append/cancel"),
	taskDragStarted: new Signal<DragData>("/task/drag/started"),
	taskDragEnded:  new Signal<DropResult>("/task/drag/ended"),

	// Сигнал для подсветки и скролла к задаче
	highlightAndScrollToTask: new Signal<{ taskId: string; columnId: string; tempId?: string }>("/task/highlight_scroll"),

	columnDragOver: new Signal<any>("/column/drag/over"),
	columnDragStarted: new Signal<void>("/column/drag/started"),
	columnDragEnded: new Signal<void>("/column/drag/ended"),
	columnDragLeave: new Signal<any>("/column/drag/leave"),
	columnEditStart: new Signal<EntityID>("/column/edit/start"),
	columnEditFinish: new Signal<EntityID>("/column/edit/finish")


};
(window as any).signals = AppSignals;